import { MutationTree } from 'vuex';
import * as MT from './mutationTypes';
import { IAssociateUserState } from './state';
import { PaginationMeta, AssociateUser, AssociateUserFilter } from '../types';

/*--------------------------------------------------/
 * User Mutations
 *--------------------------------------------------*/
export const AssociateUserMutations: IAssociateUserMutations = {
  [MT.SET_ASSOCIATE_USERS]: (
    state: IAssociateUserState,
    associateUsers: AssociateUser[]
  ) => (state.associateUsers = associateUsers),
  [MT.SET_PAGINATION_META]: (
    state: IAssociateUserState,
    paginationMeta: PaginationMeta
  ) => (state.associateUserPaginationMeta = paginationMeta),
  [MT.SET_APPLIED_ASSOCIATE_USER_FILTER]: (
    state: IAssociateUserState,
    appliedFilter: AssociateUserFilter
  ) => (state.appliedFilter = appliedFilter)
};

/*--------------------------------------------------/
 * User Mutations Tree Interface
 *--------------------------------------------------*/
export interface IAssociateUserMutations
  extends MutationTree<IAssociateUserState> {
  [MT.SET_ASSOCIATE_USERS](
    state: IAssociateUserState,
    users: AssociateUser[]
  ): void;
  [MT.SET_PAGINATION_META](
    state: IAssociateUserState,
    paginationMeta: PaginationMeta
  ): void;
  [MT.SET_APPLIED_ASSOCIATE_USER_FILTER](
    state: IAssociateUserState,
    appliedFilter: AssociateUserFilter
  ): void;
}
